import {
	ADD_ANNOTATION,
	APPEND_ANNOTATION_STATE,
	CLEAR_MAPS_STATE,
	DELETE_ANNOTATION,
	INIT_MAP_STATE,
	REMOVE_MAPS_STATE,
	UPDATE_ANNOTATION_STATE,
	UPDATE_BLOOD_ANNOTATION_STATE,
	UPDATE_DISPLAY_SETTING,
	UPDATE_FIELD_DISPLAY_SETTING,
	UPDATE_GRID_STATE,
	UPDATE_IHC_STATE,
	UPDATE_MAP_STATE,
	UPDATE_SLIDE,
	UPDATE_SELECTED_ANNOTATION_LIST,
	DELETED_SLIDE_ERROR,
	PERMISSION_DENIED_ERROR,
	MAINTAIN_MAPS_STATE_FOR_SLIDE_IDS,
	SLIDE_NOT_FOUND_ERROR
} from "../redux_constants/maps.state.const";

// TODO: [Priyanshu] add default values for all the fields to be used in the map state
const initialMapState = {
	x: -1,
	y: -1,
	z: 0,
	r: -1,
	digitalZoomStatus: false,
	zStackLevel: 0,
	gridState: {
		grid: false,
		color: "#e91e63",
		spacing: 400,   // in µm
		width: 3,
		fullExtent: true,
		dynamic: false,
		stepCord: 2,
		circleLayer: true
	},
	deletedSlideError : false,
	permissionDenied : false,
}

/*
 * {mapId: {x, y, z, r, digitalZoomStatus, zStackLevel, gridState, slide, displaySetting, annotations, bloodAnnotations,
 * ihcAnnotations}}
 *
 */
export const mapsStateReducer = (state = {}, action) => {
	if (action.type.includes("UPDATE") && !Object.keys(state).includes(action.mapId))
		return state;

	switch (action.type) {

		case CLEAR_MAPS_STATE:
			return {}

		case MAINTAIN_MAPS_STATE_FOR_SLIDE_IDS:
			let map_state = {};
			const slideIds = [];
			for(const mapId in state){
				if(action.slideIds.includes(state[mapId].slideId) && !slideIds.includes(state[mapId].slideId)){
					slideIds.push(state[mapId].slideId);
					map_state[mapId] = state[mapId];
				}
			}
			return map_state

		case REMOVE_MAPS_STATE:
			//remove action.mapId from state
			delete state[action.mapId];
			return {...state};

		case INIT_MAP_STATE:
			// id -> is created from uuid() function, and it will override if it is already exist in the url state
			Object.assign(state, {
				[action.mapId]: {
					...initialMapState,
					...action.mapState,
					id: action.mapId,
				}
			});
			return {...state};

		case UPDATE_MAP_STATE:
			Object.assign(state, {
				[action.mapId]: {
					...state[action.mapId],
					...action.mapState,
				}
			});
			return {...state};

		case UPDATE_SLIDE:
			Object.assign(state[action.mapId], {
				slide: {
					...state[action.mapId].slide,
					...action.slide,
				}
			});
			return {...state};

		case UPDATE_GRID_STATE:
			Object.assign(state[action.mapId], {
				gridState: {
					...state[action.mapId].gridState,
					...action.gridState,
				}
			});
			return {...state};

		case UPDATE_DISPLAY_SETTING:
			Object.assign(state[action.mapId], {
				displaySetting: {
					...state[action.mapId].displaySetting,
					...action.displaySetting,
				}
			});
			return {...state};

		case UPDATE_FIELD_DISPLAY_SETTING:
			Object.assign(state[action.mapId], {
				fieldDisplaySetting: {
					...state[action.mapId].fieldDisplaySetting,
					...action.fieldDisplaySetting,
				}
			});
            return {...state};

        case UPDATE_ANNOTATION_STATE:
            Object.assign(state[action.mapId], {
                annotationState: {
                    ...state[action.mapId].annotationState,
                    ...action.annotationState,
                }
            });
            return {...state};

        case APPEND_ANNOTATION_STATE:
            Object.assign(state[action.mapId], {
                annotationState: {
                    ...state[action.mapId].annotationState,
                    ...action.annotationState,
                    annotations: [...state[action.mapId].annotationState.annotations, ...action.annotationState.annotations]
                }
            });
            return {...state};

		case UPDATE_SELECTED_ANNOTATION_LIST:
			let prevSelectedAnnos = state[action.mapId].annotationState.selectedAnnotations || [];
			let selectedAnnosNew = prevSelectedAnnos;

			if(action.isAddOperation){
				selectedAnnosNew = prevSelectedAnnos.concat(action.annotationIdList);
				selectedAnnosNew = [...new Set(selectedAnnosNew)];
			} else if(!action.isAddOperation) {
				selectedAnnosNew = prevSelectedAnnos.filter(annoId => !action.annotationIdList.includes(annoId));
			}

			Object.assign(state[action.mapId], {
				annotationState: {
					...state[action.mapId].annotationState,
					selectedAnnotations: selectedAnnosNew,
				}
			});

			return {...state};

        // TODO: [Priyanshu] id based keys object instead of array
        case ADD_ANNOTATION:
            Object.assign(state[action.mapId], {
                annotationState: {
                    ...state[action.mapId].annotationState,
                    // sort in decrement order by id, same way it's coming from backend
                    annotations: [action.annotation, ...state[action.mapId].annotationState.annotations.filter(
                        annotation => annotation.id !== action.annotation.id)]
                        .sort((annotation1, annotation2) => annotation2.id - annotation1.id),
				}
			});
			return {...state};

		case DELETE_ANNOTATION:
			Object.assign(state[action.mapId], {
				annotationState: {
					...state[action.mapId].annotationState,
					annotations: [...state[action.mapId].annotationState.annotations.filter(
						annotation => annotation.id !== action.annotationId)],
				}
			});
			return {...state};

		//Blood Annotations Layer Handler

		case UPDATE_BLOOD_ANNOTATION_STATE:
			return Object.assign({}, state, {
				[action.mapId]: {
					...state[action.mapId],
					bloodAnnotationState: {
						...state[action.mapId].bloodAnnotationState,
						...action.bloodAnnotationState,
					}
				}
			});

		case UPDATE_IHC_STATE:
			Object.assign(state[action.mapId], {
				ihcState: {
					...state[action.mapId].ihcState,
					...action.ihcState,
				}
			});
			return {...state};

		case DELETED_SLIDE_ERROR:
			Object.assign(state[action.mapId], {
				deletedSlideError : true,
			});
			return {...state};

		case SLIDE_NOT_FOUND_ERROR:
			Object.assign(state[action.mapId], {
				notFoundError : true,
			});
			return {...state};

		case PERMISSION_DENIED_ERROR:
			Object.assign(state[action.mapId], {
				permissionDenied : true,
			});
			return {...state};

		default:
			return state;
	}
}